export const materialSkuDirectory = [
  {
    skuCode: "MB-CEM-OPC-43-50KG",
    title: "Cement OPC 43 Grade 50kg Bag",
    category: "Cement",
    subcategory: "Cement & Concrete",
    unit: "bag",
    aliases: ["43 grade cement", "opc 43 cement", "cement 50kg"],
  },
  {
    skuCode: "MB-CEM-PPC-50KG",
    title: "Cement PPC 50kg Bag",
    category: "Cement",
    subcategory: "Cement & Concrete",
    unit: "bag",
    aliases: ["ppc cement", "portland pozzolana cement"],
  },
  {
    skuCode: "MB-STL-TMT-08MM",
    title: "TMT Bar 8mm",
    category: "Steel",
    subcategory: "Steel & TMT",
    unit: "piece",
    aliases: ["8mm tmt", "tmt rod 8mm"],
  },
  {
    skuCode: "MB-STL-TMT-12MM",
    title: "TMT Bar 12mm",
    category: "Steel",
    subcategory: "Steel & TMT",
    unit: "piece",
    aliases: ["12mm tmt", "tmt rod 12mm"],
  },
  {
    skuCode: "MB-HDW-SCR-WOOD-CSK-PH-8G-1IN-ZINC",
    title: "Wood Screw CSK Philips 8G 1in Zinc",
    category: "Hardware",
    subcategory: "Fasteners",
    unit: "box",
    aliases: ["wood screw 1 inch", "carpenter screw", "8g wood screw"],
  },
  {
    skuCode: "MB-HDW-SCR-DRYWALL-BUGLE-PH-6G-1.5IN-BLACK",
    title: "Drywall Screw Bugle Philips 6G 1.5in Black",
    category: "Hardware",
    subcategory: "Fasteners",
    unit: "box",
    aliases: ["drywall screw", "gypsum screw", "black drywall screw"],
  },
  {
    skuCode: "MB-HDW-SCR-ROOF-HEX-12G-2IN-GALV-EPDM",
    title: "Roofing Screw Hex 12G 2in Galvanized EPDM",
    category: "Hardware",
    subcategory: "Fasteners",
    unit: "box",
    aliases: ["roofing screw", "purlin screw", "sheet screw"],
  },
  {
    skuCode: "MB-HDW-NUT-HEX-M10-ZINC",
    title: "Hex Nut M10 Zinc",
    category: "Hardware",
    subcategory: "Fasteners",
    unit: "box",
    aliases: ["m10 nut", "hex nut", "nut bolt nut"],
  },
  {
    skuCode: "MB-HDW-WASH-SPR-M10-ZINC",
    title: "Spring Washer M10 Zinc",
    category: "Hardware",
    subcategory: "Fasteners",
    unit: "box",
    aliases: ["m10 spring washer", "lock washer", "spring washer"],
  },
  {
    skuCode: "MB-HDW-ANC-CHEM-M12-100MM-ZINC",
    title: "Chemical Anchor Stud M12 100mm Zinc",
    category: "Hardware",
    subcategory: "Anchors",
    unit: "piece",
    aliases: ["chemical anchor", "anchor stud", "m12 anchor stud"],
  },
  {
    skuCode: "MB-PLB-PVC-PIPE-20MM-10KG-10FT",
    title: "PVC Pipe 20mm 10kg 10ft",
    category: "Plumbing",
    subcategory: "Pipes",
    unit: "piece",
    aliases: ["3/4 inch pvc pipe", "20mm pvc", "pressure pvc pipe"],
  },
  {
    skuCode: "MB-PLB-GI-PIPE-25MM-MEDIUM-20FT",
    title: "GI Pipe 25mm Medium 20ft",
    category: "Plumbing",
    subcategory: "Pipes",
    unit: "piece",
    aliases: ["1 inch gi pipe", "iron pipe", "25mm gi pipe"],
  },
  {
    skuCode: "MB-PLB-PVC-TEE-25MM-PRESSURE",
    title: "PVC Tee 25mm Pressure",
    category: "Plumbing",
    subcategory: "Pipe Fittings",
    unit: "piece",
    aliases: ["25mm pvc tee", "tee fitting", "pvc tee"],
  },
  {
    skuCode: "MB-PLB-UPVC-UNION-25MM-THREADED",
    title: "UPVC Union 25mm Threaded",
    category: "Plumbing",
    subcategory: "Pipe Fittings",
    unit: "piece",
    aliases: ["25mm union", "upvc union", "pipe union"],
  },
  {
    skuCode: "MB-PLB-VAL-BALL-25MM-BRASS-PN16",
    title: "Ball Valve 25mm Brass PN16",
    category: "Plumbing",
    subcategory: "Valves",
    unit: "piece",
    aliases: ["25mm ball valve", "water valve", "brass ball valve"],
  },
  {
    skuCode: "MB-PLB-VAL-FOOT-32MM-BRASS-HEAVY",
    title: "Foot Valve 32mm Brass Heavy",
    category: "Plumbing",
    subcategory: "Valves",
    unit: "piece",
    aliases: ["foot valve", "suction valve", "pump foot valve"],
  },
  {
    skuCode: "MB-ELE-SWITCH-06A-1M-WHITE",
    title: "Modular Switch 6A 1 Module White",
    category: "Electrical",
    subcategory: "Switchgear",
    unit: "piece",
    aliases: ["6a switch", "1m switch", "modular switch 6a"],
  },
  {
    skuCode: "MB-ELE-SOCKET-16A-3M-WHITE",
    title: "Modular Socket 16A 3 Module White",
    category: "Electrical",
    subcategory: "Switchgear",
    unit: "piece",
    aliases: ["16a socket", "power socket", "3m socket"],
  },
  {
    skuCode: "MB-ELE-WIRE-HOUSE-1.5SQMM-RED-FR-90M",
    title: "House Wire 1.5 sqmm Red FR 90m",
    category: "Electrical",
    subcategory: "Wires & Cables",
    unit: "coil",
    aliases: ["1.5 sqmm wire", "house wire", "red wire coil"],
  },
  {
    skuCode: "MB-ELE-CONDUIT-20MM-MEDIUM-10FT",
    title: "Electrical Conduit 20mm Medium 10ft",
    category: "Electrical",
    subcategory: "Conduits",
    unit: "piece",
    aliases: ["20mm conduit", "pvc conduit", "wire pipe"],
  },
  {
    skuCode: "MB-ELE-DB-8WAY-SPN-SURFACE",
    title: "DB Box 8 Way SPN Surface",
    category: "Electrical",
    subcategory: "Switchgear",
    unit: "piece",
    aliases: ["db box", "distribution board", "mcb box"],
  },
  {
    skuCode: "MB-PNT-PUTTY-20KG-INTERIOR",
    title: "Wall Putty 20kg Interior",
    category: "Paint",
    subcategory: "Paints & Primers",
    unit: "bag",
    aliases: ["putty 20kg", "wall putty", "putty bag"],
  },
  {
    skuCode: "MB-PNT-EML-INT-MATTE-10L-WHITE-PREMIUM",
    title: "Interior Emulsion Matte 10L White Premium",
    category: "Paint",
    subcategory: "Paints & Primers",
    unit: "bucket",
    aliases: ["paint 10 litre", "interior emulsion", "wall paint 10l"],
  },
  {
    skuCode: "MB-PNT-ENML-GLOSS-1L-BLACK",
    title: "Enamel Paint Gloss 1L Black",
    category: "Paint",
    subcategory: "Paints & Primers",
    unit: "tin",
    aliases: ["black enamel", "metal paint", "enamel 1 litre"],
  },
  {
    skuCode: "MB-WPF-COAT-ACRYLIC-20KG-TERRACE",
    title: "Waterproof Coating Acrylic 20kg Terrace",
    category: "Waterproofing",
    subcategory: "Construction Chemicals",
    unit: "bucket",
    aliases: ["waterproof coating", "terrace waterproofing", "damp proof coat"],
  },
  {
    skuCode: "MB-WPF-GROUT-5KG-GREY-STANDARD",
    title: "Grout 5kg Grey Standard",
    category: "Waterproofing",
    subcategory: "Construction Chemicals",
    unit: "packet",
    aliases: ["tile grout", "joint filler", "grey grout"],
  },
  {
    skuCode: "MB-ADH-TILE-C2-20KG-FLOOR",
    title: "Tile Adhesive C2 20kg Floor",
    category: "Adhesives",
    subcategory: "Tile Adhesives",
    unit: "bag",
    aliases: ["tile adhesive", "tile glue", "tile fixing powder"],
  },
  {
    skuCode: "MB-SEA-SIL-300ML-NEUTRAL-CLEAR",
    title: "Silicone Sealant 300ml Neutral Clear",
    category: "Sealants",
    subcategory: "Silicone Sealants",
    unit: "cartridge",
    aliases: ["silicone sealant", "clear sealant", "bathroom sealant"],
  },
  {
    skuCode: "MB-TIL-VIT-2X2-MATTE-8MM-BEIGE",
    title: "Vitrified Tile 2x2 Matte 8mm Beige",
    category: "Tiles",
    subcategory: "Tiles & Flooring",
    unit: "box",
    aliases: ["2x2 tile", "vitrified floor tile", "matte tile"],
  },
  {
    skuCode: "MB-SAN-WC-WESTERN-FLR",
    title: "Western WC Floor Mounted",
    category: "Sanitary",
    subcategory: "Sanitaryware",
    unit: "piece",
    aliases: ["western commode floor", "floor mounted wc"],
  },
  {
    skuCode: "MB-SAN-WB-550MM",
    title: "Wash Basin 550mm",
    category: "Sanitary",
    subcategory: "Sanitaryware",
    unit: "piece",
    aliases: ["wash basin 22 inch", "basin 550mm"],
  },
  {
    skuCode: "MB-BRK-RED-STD",
    title: "Red Brick Standard",
    category: "Bricks",
    subcategory: "Masonry",
    unit: "piece",
    aliases: ["red brick", "standard brick"],
  },
  {
    skuCode: "MB-SND-RIVER-UNIT",
    title: "River Sand",
    category: "Sand",
    subcategory: "Aggregates",
    unit: "ton",
    aliases: ["river sand", "fine sand"],
  },
];

export function getSkuDirectoryCategories() {
  return Array.from(new Set(materialSkuDirectory.map((item) => item.category)));
}

export function findMaterialSkuByCode(skuCode) {
  return materialSkuDirectory.find((item) => item.skuCode === skuCode) || null;
}

export function normalizeMaterialSkuRecord(item) {
  if (!item) return null;

  return {
    id: item.id || item.skuCode || item.sku_code || "",
    skuCode: item.skuCode || item.sku_code || "",
    title: item.title || "",
    category: item.category || "General",
    unit: item.unit || "unit",
    aliases: Array.isArray(item.aliases) ? item.aliases : [],
    subcategory: item.subcategory || null,
    brand: item.brand || null,
    sizeLabel: item.sizeLabel || item.size_label || null,
  };
}
